import React from 'react';
import '../SharedControlPanel.scss';
import './TranscoderPanel.scss';
import TranscoderModeInput from '../../../../InputComponents/TranscoderModeInput/TranscoderModeInput';
import TranscoderVideoPanel from '../TranscoderVideoPanel/TranscoderVideoPanel';
import TranscoderAudioPanel from '../TranscoderAudioPanel/TranscoderAudioPanel';
import useProject from '../../../../../hooks/useProject';

const TranscoderPanel = () => {
  const { project } = useProject();

  return (
    <div className="transcoder-panel">
      {project?.createdByUser?.isAdmin === true && (
        <>
          <div className="transcoder-panel-section level">
            <div className="transcoder-panel-section-content-value">
              <TranscoderModeInput />
            </div>
          </div>
        </>
      )}

      <div className="transcoder-panel-section level">
        <div className="transcoder-panel-section-content-value">
          <TranscoderVideoPanel />
        </div>
      </div>

      <div className="transcoder-panel-section level">
        <div className="transcoder-panel-section-content-value">
          <TranscoderAudioPanel />
        </div>
      </div>
    </div>
  );
};

export default React.memo(TranscoderPanel);
